export const FinancialPlanningEN = {
  DAILY_LIFE: 'Daily Life',
  HOUSING: 'Housing',
  HOUSING_DESCRIPTION: 'rent, mortgage, utilities, maintenance',
  FOOD_GROCERIES: 'Food & groceries',
  TRANSPORTATION: 'Transportation',
  TRANSPORTATION_DESCRIPTION: 'car, public transport, fuel, insurance',
  HEALTH_WELLNESS: 'Health & wellness',
  HEALTH_WELLNESS_DESCRIPTION: 'insurance, medical, gym',
  CLOTHING_PERSONAL_CARE: 'Clothing & personal care',
  DIGITAL: 'Digital',
  DIGITAL_DESCRIPTION: 'phone, internet, streaming',
  EVERYDAY_ACTIVITIES: 'Everyday activities',
  EVERYDAY_ACTIVITIES_DESCRIPTION: 'childcare, school fees, membership',
  CASUAL_EATING_OUT: 'Casual eating out',
  CASUAL_EATING_OUT_DESCRIPTION: 'e.g. lunch out, weekday dinners',

  LIFESTYLE_EXPERIENCES: 'Lifestyle & Experiences',
  TRAVEL_VACATIONS: 'Travel & vacations',
  SECOND_HOME_OR_WEEKEND_CABIN: 'Second home or weekend cabin',
  PERSONAL_OR_CREATIVE_PROJECTS: 'Personal or creative projects',
  PASSION_INVESTMENTS: 'Passion investments',
  PASSION_INVESTMENTS_DESCRIPTION: 'art, wine, collectibles',
  HOBBIES: 'Hobbies',
  HOBBIES_DESCRIPTION: 'gear, events, coaching',
  LIFESTYLE_UPGRADES: 'Lifestyle upgrades',
  LIFESTYLE_UPGRADES_DESCRIPTION: 'e.g. kitchen renovation, EV',
  SPECIAL_DIETING_EVENTS: 'Special dining & events',
  SPECIAL_DIETING_EVENTS_DESCRIPTION:
    'e.g. monthly dinner with the whole family at restaurant',

  GIVING_AND_LEGACY: 'Giving & Legacy',
  GIFTS_TO_CHILDREN: 'Gifts to children',
  GIFTS_TO_CHILDREN_DESCRIPTION: 'e.g. apartment down payment',
  SUPPORT_FOR_FAMILY_AND_FRIENDS: 'Support for family and friends',
  CHARITABLE_DONATIONS: 'Charitable donations',
  INHERITANCE_PLANNING: 'Inheritance planning',
  FAMILY_TRUST_OR_FUTURE_FUNDS: 'Family trust or future funds',
  GIVE_WHILE_LIVING_GOALS: '“Give while living” goals',

  Me: 'Me',
  Family: 'Family',
  'My Partner': 'My Partner',
  'With Friends': 'With Friends',

  DESCRIPTION_OPTIONAL: 'Description (optional):',
  TAGS_OPTIONAL: 'Tags (optional):',

  ESSENTIAL: 'Essential',
  USEFUL: 'Useful',
  NOT_AT_ALL: 'Not at all',

  HIGHEST: 'Highest',
  MODERATE: 'Moderate',

  JOYFUL: 'Joyful',
  CONTENT: 'Content',
  NEUTRAL: 'Neutral',

  HOW_DOES_THIS_ALIGN_WITH_YOUR_NEEDS: 'How does this align with your needs?',
  HOW_DOES_THIS_ALIGN_WITH_MY_PURPOSE: 'How does this align with my purpose?',
  HOW_HAPPY_DOES_IT_MAKE_YOU: 'How happy does it make you?',
  HOW_ESSENTIAL_IS_THIS: 'How essential is this?',
  HOW_OFTEN_DO_YOU_WANT_TO_DO_IT: 'How often do you want to do it?',
  WHEN_DO_YOU_USUALLY_PAY_FOR_THIS: 'When do you usually pay for this?',
  WHEN_DO_YOU_WANT_TO_SPEND_ON_THIS: 'When want to spend on this?',

  NECESSITY: 'Necessity',
  PURPOSE_HAPPINESS: 'Purpose / Happiness',
};
